/* eslint-disable import/no-anonymous-default-export */
import { Professor } from '../models';
import {QueryParams, IProfessor, SimpleQueryParams} from '../types';
import api, {getAll, create, update, getOne, listAll, RequestError, RequestResponse, makeCrudObject} from './api';

const endpoint = 'professores';

export type Params = {

}

export default {
    ...makeCrudObject<Professor>(endpoint),
    all: async (params?: QueryParams) => getAll<IProfessor>({ endpoint, params }),
    listAll: async (params?: Params) => listAll<IProfessor>({ endpoint, params }),
    one: async (id: string, params?:SimpleQueryParams ) => getOne<IProfessor>({ endpoint, id, params }),
    create: async (formData: Partial<IProfessor>) => create<IProfessor>({ endpoint, formData }),
    update: async (id: string, formData: Partial<IProfessor>) => update<IProfessor>({ endpoint, formData, id }),
    async getProfessorHorarios(dataConsulta?: any): Promise<RequestError | RequestResponse<any[]>> {
        try {
            const { data } = await api.get(`${endpoint}/horarios${dataConsulta}`);
            return { data, isError: false };
        } catch (err: any) {
            console.log(err);
            return {
                data: err?.response?.data ?? { message: 'Falha ao processar requisição' },
                isError: true
            };
        }
    },
    async getResumoContratos(props: { professor_id: number; year: number; month: number }): Promise<RequestError | RequestResponse<any[]>> {
        try {
            const query = new URLSearchParams(props as any).toString();
            const { data } = await api.get(`/professores/resumo-contratos?${query}`);
            return { data, isError: false };
        } catch (err: any) {
            console.log(err);
            return {
                data: err?.response?.data ?? { message: 'Falha ao processar requisição' },
                isError: true
            };
        }
    },
    async getResumo(props?: { categoria_id?: number, professor_id?: number }): Promise<RequestError | RequestResponse<any[]>> {
        try {
            let query = (props?.categoria_id || props?.professor_id) ? new URLSearchParams(props as any).toString() : '';
            const { data } = await api.get(`/professores/resumo?${query}`);
            return { data, isError: false };
        } catch (err: any) {
            console.log(err);
            return {
                data: err?.response?.data ?? { message: 'Falha ao processar requisição' },
                isError: true
            };
        }
    },
    async getPresencas(props: { professor_id: number }): Promise<RequestError | RequestResponse<any[]>> {
        try {
            const query = new URLSearchParams(props as any).toString();
            const { data } = await api.get(`/professores/presencas?${query}`);
            return { data, isError: false };
        } catch (err: any) {
            console.log(err);
            return {
                data: err?.response?.data ?? { message: 'Falha ao processar requisição' },
                isError: true
            };
        }
    },
    async setAlunoPresenca(props: any): Promise<RequestError | RequestResponse<any>> {
        try {
            const { data } = await api.post(`/professores/presencas`, props);
            return { data, isError: false };
        } catch (err: any) {
            console.log(err);
            return {
                data: err?.response?.data ?? { message: 'Falha ao processar requisição' },
                isError: true
            };
        }
    },
    async getAlunoData(props: { aluno_id: number; }): Promise<RequestError | RequestResponse<any>> {
        try {
            const query = new URLSearchParams(props as any).toString();
            const { data } = await api.get(`/professores/aluno-data?${query}`);
            return { data, isError: false };
        } catch (err: any) {
            console.log(err);
            return {
                data: err?.response?.data ?? { message: 'Falha ao processar requisição' },
                isError: true
            };
        }
    }
};
